import React from 'react';
import styles from './PlacesTable.module.css';

import {Loader, Table} from '@mantine/core';
import { useNavigate } from 'react-router-dom';

import ArrowsSvg from '@icons/Arrows.svg';
import SortUpSvg from '@icons/SortUp.svg';
import SortDownSvg from '@icons/SortDown.svg';

import { useDisclosure } from '@mantine/hooks';
import { Modal } from '@mantine/core';
import ModalAttention from './ModalAttention';
import { useTranslation } from 'react-i18next';

const PlacesTable = ({ places, search, sortName, sortValue, sort, isLoading }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [opened, { open, close }] = useDisclosure(false);

  const statuses = {
    RECALLED: {
      color: 'orange',
      text: t('statuses.recalled')
    },
    UNBOUND: {
      color: 'orange',
      text: t('statuses.unbound')
    },
    ON_REVIEW: {
      color: '#3A86FF',
      text: t('statuses.onreview')
    },
    APPROVED: {
      color: '#68BF61',
      text: t('statuses.approved')
    },
    PUBLISHED: {
      color: '#68BF61',
      text: t('statuses.published')
    },
    REJECTED: {
      color: 'red',
      text: t('statuses.rejected')
    },
    READY_TO_PUBLISH: {
      color: '#FF5959',
      text: t('statuses.ready_to_publish')
    },
    INFORMATION_REQUIRED: {
      color: '#FFB303',
      text: t('statuses.information_required')
    }
  }

  const handleClick = (place) => {
    if (place) {
      navigate(`/places/${place.placeKey}`)
    } else {
      open();
    }
  }

  const getIcon = (name) => {
    if (sortName !== name) {
      return ArrowsSvg;
    }

    if (sortValue === -1) {
      return SortUpSvg
    } else {
      return SortDownSvg;
    }
  }

  const rows = places.map(({
    claim,
    status,
    place
  }) => {
    const data = place || claim;
    return (
        <Table.Tr key={data.placeKey || data.id } className={styles.bodyTr} onClick={() => handleClick(place)}>
          <Table.Td className={styles.nameTh}>{data.placeName}</Table.Td>
          <Table.Td
              className={styles.statusTh}
              style={{ color: statuses[status]?.color }}
          >
            {statuses[status]?.text}
          </Table.Td>
          <Table.Td className={styles.addressTh}>{data?.placeAddress}</Table.Td>
        </Table.Tr>
    )
  });

  if(isLoading) return (
      <div className={styles.loader}>
        <Loader/>
      </div>
  )
  else return(
    <div className={styles.wrapper}>
      <Table stickyHeader stickyHeaderOffset={0}>
        <Table.Thead className={styles.thead}>
          <Table.Tr className={styles.headTr}>
            <Table.Th className={styles.headThName}>
              <div className={styles.contentName}>
                {t('places.table.header1')}

                <div className={styles.sort}>
                  <img src={getIcon('name')} onClick={() => sort('name')} />
                </div>
              </div>
            </Table.Th>
            <Table.Th className={styles.headThStatus}>
              <div className={styles.content}>
                {t('places.table.header2')}

                <div className={styles.sort}>
                  <img src={getIcon('status')} onClick={() => sort('status')} />
                </div>
              </div>
            </Table.Th>
            <Table.Th className={styles.headThAdress}>
              <div className={styles.content}>
                {t('places.table.header3')}

                <div className={styles.sort}>
                  <img src={getIcon('address')} onClick={() => sort('address')} />
                </div>
              </div>
            </Table.Th>
          </Table.Tr>
        </Table.Thead>
        <Table.Tbody>{rows}</Table.Tbody>

        <Modal
          opened={opened}
          style={{ width: '571px' }}
          size={571}
          onClose={close}
          title={t('attentionModal.title')}
          centered
          className={styles.modal}
        >
          <ModalAttention
            onClose={close}
          />
        </Modal>
      </Table>
      {places.length === 0 && (
        <div className={styles.empty}>
          {search?.length > 0 ? t('places.filtered.empty') : t('places.empty')}
        </div>
      )}
    </div>
  )
}

export default PlacesTable;
